@if (loading()) {
  <div
    class="h-120 w-full flex justify-center items-center text-primary dark:text-primary-darkmode"
  >
    <ui-loading-spinner size="24" />
  </div>
} @else if (error()) {
  <app-error-component
    class="h-120 w-full block"
    [enableRetry]="true"
    (clickRetry)="clickReload.emit()"
  />
} @else {
  <table class="w-full">
    <thead>
      <tr>
        <th
          class="text-start text-sm font-semibold leading-6 min-h-14 p-3 border-b border-outline dark:border-outline-darkmode"
        >
          {{ 'cockpit.analysis.hpfc.detail.tableHeaderPeriod' | transloco }}
        </th>
        <th
          class="text-end text-sm font-semibold leading-6 min-h-14 p-3 border-b border-outline dark:border-outline-darkmode"
        >
          {{ 'cockpit.analysis.hpfc.detail.tableHeaderPrice' | transloco }}
        </th>
      </tr>
    </thead>
    <tbody>
      @for (price of prices(); track $index) {
        <tr [class.border-t]="$index !== 0" class="border-outline dark:border-outline-darkmode">
          <td class="text-sm leading-6 min-h-14 p-3">
            @switch (granularity()) {
              @case ('YEAR')
              @case ('MONTH') {
                {{ price.validFrom | date: 'dd.MM.yyyy' }}
              }
              @case ('WEEK') {
                {{ price.validFrom | date: 'cccc HH:mm' }}
              }
              @case ('DAY') {
                {{ price.validFrom | date: 'HH:mm' }}
              }
            }
          </td>
          <td class="text-end leading-6 text-sm min-h-14 p-3">
            {{ price.price | convertPrice: showEurMwh() | germanNumber: 2 }}
            {{ unitKey() | transloco }}
          </td>
        </tr>
      }
    </tbody>
  </table>
}
